<template>
    <v-app>
        <Header v-if="headerVisibilityState"></Header>
        <SiderLeft v-if="siderLeftVisibilityState"></SiderLeft>

                <router-view></router-view>

        <SiderRight v-if="siderRightVisibilityState"></SiderRight>
        <Footer></Footer>
        <Snackbar></Snackbar>
    </v-app>
</template>

<script>

    import Header from "./layout/Header"
    import SiderLeft from "./layout/SiderLeft"
    import Footer from "./layout/Footer"
    import SiderRight from "./layout/SiderRight";
    import Overlay from "./layout/Overlay"
    import store from "../store"
    import Snackbar from "./layout/Overlay";

    export default {
        name: "App",

        components: {
            Snackbar,
            Header,
            Footer,
            SiderLeft,
            SiderRight
        },

        computed: {
            siderLeftVisibilityState() {
                return store.state.siderLeftVisibility
            },

            siderRightVisibilityState() {
                return store.state.siderRightVisibility
            },

            headerVisibilityState() {
                return store.state.headerVisibility
            }
        }
    };

</script>

<style>

</style>
